"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.checkboxTypes = exports.TRACK_COLOR = exports.THUMB_COLOR = exports.ICON_UNCHECKED = exports.ICON_CHECKED = void 0;
var checkboxTypes = exports.checkboxTypes = {
  normal: 'normal',
  "switch": 'switch'
};
var TRACK_COLOR = exports.TRACK_COLOR = '#13ba97';
var THUMB_COLOR = exports.THUMB_COLOR = '#FFF';
var ICON_CHECKED = exports.ICON_CHECKED = 'ion-android-checkbox';
var ICON_UNCHECKED = exports.ICON_UNCHECKED = 'ion-android-checkbox-outline-blank';
var _default = exports["default"] = {
  TRACK_COLOR: TRACK_COLOR,
  THUMB_COLOR: THUMB_COLOR,
  checkboxTypes: checkboxTypes,
  ICON_CHECKED: ICON_CHECKED,
  ICON_UNCHECKED: ICON_UNCHECKED
};